import { z, ZodIssueCode } from 'zod';

z.config({
  customError: (issue): string => {
    if (issue.code === ZodIssueCode.too_big && 'maximum' in issue && 'origin' in issue) {
      const { origin, maximum } = issue;

      if (origin === 'string') {
        return `String must contain at most ${maximum} character(s)`;
      }

      if (origin === 'number') {
        return `Number must be less than or equal to ${maximum}`;
      }
    }

    return '';
  },
});
